module.exports = __webpack_public_path__ + "static/media/birminghamMap.4014d4a0.jpg";